import { displayDate } from '../common/datePresentation';
import { groupSettlementLessons, settlementLessonSchedule, settlementLessonTypeLabel, shortParticipantLabel } from './teacherSettlementGroups';

const headings = t => ['teacher', 'month', 'status', 'date', 'lesson', 'duration', 'students', 'attendance', 'eligible', 'amount', 'note'].map(t);
export function payrollLessonLabel(lesson, t) {
  const schedule = settlementLessonSchedule(lesson);
  const identity = [schedule.dayOfWeek && t(`weekdays.${schedule.dayOfWeek}`), schedule.startTime].filter(Boolean).join(' ');
  const participants = (lesson.participants || []).map(shortParticipantLabel).filter(Boolean).join(', ');
  const actual = schedule.moved ? [schedule.actualDayOfWeek && t(`weekdays.${schedule.actualDayOfWeek}`), schedule.actualStartTime].filter(Boolean).join(' ') : '';
  return [identity || t('unknownLesson'), settlementLessonTypeLabel(lesson.classTypeId, t),
    actual && `\u2192 ${actual}`, participants].filter(Boolean).join(' \u00b7 ');
}
export function payrollRows(reports, t, language = 'pl') {
  return reports.flatMap(report => {
    const lessons = report.lessonView || report.lines.filter(line => line.kind !== 'fixed');
    const full = groupSettlementLessons(lessons).flatMap(group => group.lessons);
    return [
      ...full.map(line => [report.teacherName, report.month, t(report.status), displayDate(line.date, language), payrollLessonLabel(line, t),
        line.durationMinutes ?? t('unknown'), line.rosterKnown === true
          ? new Set((line.participants || []).filter(item => !item.isGuest && !item.isMakeup).map(item => item.id)).size : line.regularStudentsCount ?? t('unknown'),
        t(`attendanceStates.${line.attendanceState || 'unknown'}`), t(line.payoutEligible ? 'yes' : 'no'),
        line.amountCents === null ? t('unrecordedAmount') : (Number(line.amountCents ?? Math.round((line.amount || 0) * 100)) / 100).toFixed(2), '']),
      ...report.lines.filter(line => line.kind === 'fixed').map(line => [report.teacherName, report.month, t(report.status), displayDate(line.date, language),
        t('fixed'), '', '', '', '', line.amount.toFixed(2), '']),
      ...report.corrections.map(item => [report.teacherName, report.month, t(report.status), '', t('correction'), '', '', '', '', item.amount.toFixed(2), item.note]),
      [report.teacherName, report.month, t(report.status), '', t('total'), '', '', '', '', report.totalPayoutAmount.toFixed(2), ''],
    ];
  });
}

const csvCell = value => {
  const text = String(value);
  const safe = /^[\s]*[=+\-@]/.test(text) && !/^-?\d+(\.\d+)?$/.test(text) ? `'${text}` : text;
  return `"${safe.replace(/"/g, '""')}"`;
};
export function buildPayrollCsv(reports, t, language = 'pl') {
  return `\uFEFF${[headings(t), ...payrollRows(reports, t, language)].map(row => row.map(csvCell).join(';')).join('\r\n')}`;
}

export function exportPayrollCsv(reports, month, t, language = 'pl') {
  const url = URL.createObjectURL(new Blob([buildPayrollCsv(reports, t, language)], { type: 'text/csv;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url; link.download = `teacher-settlements-${month}.csv`;
  document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function printPayroll(reports, month, t, language = 'pl') {
  const popup = window.open('', '_blank');
  if (!popup) return false;
  popup.opener = null;
  const doc = popup.document;
  doc.title = `${t('title')} ${month}`;
  const style = doc.createElement('style');
  style.textContent = '@page{size:A4 landscape;margin:12mm}body{font:11pt Arial,sans-serif}table{border-collapse:collapse;width:100%}th,td{border:1px solid #ccc;padding:5px;overflow-wrap:anywhere}thead{display:table-header-group}tr{break-inside:avoid}';
  doc.head.appendChild(style);
  const title = doc.createElement('h1'); title.textContent = doc.title; doc.body.appendChild(title);
  const table = doc.createElement('table');
  const header = doc.createElement('thead');
  const body = doc.createElement('tbody');
  [headings(t), ...payrollRows(reports, t, language)].forEach((row, index) => {
    const tr = doc.createElement('tr');
    row.forEach(value => { const cell = doc.createElement(index === 0 ? 'th' : 'td'); cell.textContent = value; tr.appendChild(cell); });
    (index === 0 ? header : body).appendChild(tr);
  });
  table.appendChild(header); table.appendChild(body); doc.body.appendChild(table);
  popup.focus(); popup.print();
  return true;
}
